import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import FormInput from 'components/forms/FormInput';
import { getSubmissionsR } from 'actions/EditorActions';
import Modal from '../../Modal';
import { deleterDispatchHelper } from '../../../actions/DeleterActions';
import Loader from '../Loader';
import Edition from './Edition';
import ProductSelection from './ProductSelection';
import { newEditionR, setVariables, setPreviewImageR } from '../../../actions/CampaignActions';
import { getDeviceType } from '../../../cc-editor/components/actions/deviceType';

class SubmissionsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNewEdition: false,
      action: 'new',
      generatingEdition: false,
      newEditionItem: null,
      newEditionTemplate: null,
      newItemName: '',
      deviceTypes: '',
      selectedSubmission: null,
    };
  }

  componentDidMount = () => {
    const {
      intl: { messages },
    } = this.props;
    this.setState({ deviceTypes: getDeviceType(), newItemName: messages?.no_product_selected });
    this.props.getSubmissionsList(this.getFilterAsString());
  };

  newEdition = (campaignId, action = '', editionId = '') => {
    this.setState({
      generatingEdition: true,
      showNewEdition: false,
    });
    const { newEditionItem, newEditionTemplate } = this.state;
    const { newEditionR } = this.props;
    const {
      intl: { messages },
    } = this.props;
    let params;
    if (action !== 'copy') {
      params = {
        template: newEditionTemplate,
        item: newEditionItem,
        campaign: campaignId,
        isSubmission: true,
        title:
          this.editionTitle.state.value === '' ? messages.campaign.new_edition_title : this.editionTitle.state.value,
      };
    } else {
      params = {
        id: editionId,
        action: 'copy',
      };
    }
    newEditionR(params);
  };

  showNewEdition = () => {
    this.setState({
      showNewEdition: true,
    });
  };

  closeNewEdition = () => {
    this.setState({
      showNewEdition: false,
    });
  };

  getFilterAsString = () => {
    const { urlData } = this.props;
    const propsUrlData = urlData || { filters: {} };
    propsUrlData.filters = propsUrlData.filters || {};
    const filterString = Object.entries(propsUrlData?.filters)
      .map(([key, values]) => {
        if (values !== undefined) {
          const encodedKey = encodeURIComponent(key);
          const encodedValues = values.map(value => encodeURIComponent(value));
          return `filters%5B${encodedKey}%5D%5B%5D=${encodedValues.join(`&filters%5B${encodedKey}%5D%5B%5D=`)}`;
        }
        return '';
      })
      .join('&');
    return filterString;
  };

  handleRemoveEditionClick = (e, editionId) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.deleteEdition(editionId, 'toTrash');
  };

  handleSubmissionClick = submission => {
    const { setSelectedSubmission } = this.props;
    this.setState({ selectedSubmission: submission });
    setSelectedSubmission(submission);
  };

  selectItem = (templateId, itemId, itemName) => {
    this.setState({
      newEditionItem: itemId,
      newEditionTemplate: templateId,
      newItemName: itemName,
    });
  };

  render() {
    const {
      list,
      intl: { messages },
      appIntl,
      onlyForSelection,
      history
    } = this.props;

    const {
      showNewEdition,
      generatingEdition,
      newEditionTemplate,
      newItemName,
      deviceTypes,
      selectedSubmission,
    } = this.state;

    const isOnlyForSelection = onlyForSelection || false;

    return (
      <>
        {typeof list !== 'undefined' ? (
          this.props.pending || typeof list !== 'object' ? (
            <Loader />
          ) : (
            <>
              {showNewEdition && !isOnlyForSelection && (
                <Modal
                  show={showNewEdition}
                  className="creacheck-modal"
                  onHide={() => this.closeNewEdition()}
                  bsSize="large"
                >
                  <Modal.Header closeButton>
                    <Modal.Title>{messages.campaign.new_edition}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="new-edition">
                      <div className="select-product">
                        <ProductSelection
                          messages={messages}
                          appIntl={appIntl}
                          history={history}
                          selectItem={this.selectItem}
                          selectedItem={newEditionTemplate}
                          deviceTypes={deviceTypes}
                        />
                      </div>
                      <div className="edition-settings">
                        <p>
                          <b>{messages.campaign.edition_item + ': '}</b>
                          {newItemName}
                        </p>
                        <FormInput
                          type="text"
                          label={messages.campaign.edition_title}
                          name="title"
                          value={messages.campaign.new_edition_title}
                          ref={ref => (this.editionTitle = ref)}
                        />
                        <Button bsStyle="default" bsSize="large" onClick={() => this.newEdition()}>
                          <i className="fas fa-plus-square bg-green" /> {messages.campaign.new_edition}
                        </Button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
              )}
              <div className="editions" style={{ marginRight: 2 + '%' }}>
                {generatingEdition ? (
                  <Loader />
                ) : (
                  <>
                    {!isOnlyForSelection && (
                      <div className="editionNew">
                        <Button
                          bsStyle="default"
                          className="new-ce"
                          disabled={generatingEdition}
                          bsSize="small"
                          onClick={() => this.showNewEdition()}
                        >
                          <i className="fas fa-plus bg-green" />
                          <span>{messages.campaign.new_edition}</span>
                        </Button>
                      </div>
                    )}
                    {this.props.list?.list?.map(edition => {
                      return (
                        <div
                          key={edition.id}
                          style={{
                            cursor: isOnlyForSelection ? 'pointer' : 'auto',
                            pointerEvents: 'auto',
                            width: 'max-content',
                          }}
                          onClick={() => {
                            if (isOnlyForSelection) {
                              this.handleSubmissionClick(edition?.id === selectedSubmission?.id ? null : edition);
                            }
                          }}
                        >
                          <Edition
                            style={{ pointerEvents: isOnlyForSelection ? 'none' : 'auto' }}
                            edition={edition}
                            appIntl={appIntl}
                            messages={messages}
                            deleter={this.handleRemoveEditionClick}
                            forceUpdate={this.forceUpdate}
                            copyEdition={this.newEdition}
                            onMobile={edition.item.category.on_mobile}
                            key={edition?.id}
                            viewOnly={isOnlyForSelection}
                            isSelected={edition?.id === selectedSubmission?.id}
                          />
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            </>
          )
        ) : (
          <Loader />
        )}
      </>
      // </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.editor.submissionsC.list,
    pending: state.editor.submissionsC.pending,
    user: state.login.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    deleteEdition: (editionId, flagOption) => {
      deleterDispatchHelper('submission', '/api/news/' + editionId + '/editions/' + flagOption + '.json', dispatch);
    },
    newEditionR: data => {
      dispatch(newEditionR(data));
    },
    setVariables: data => {
      dispatch(setVariables(data));
    },
    setPreviewImageR: data => {
      dispatch(setPreviewImageR(data));
    },
    getSubmissionsList: data => {
      dispatch(getSubmissionsR(data));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SubmissionsList)
  )
);
